const messages = {
	id: {
		translations: {
			signup: {
				title: "Daftar",
				toasts: {
					success: "User berhasil dibuat! Silakan login!",
					fail: "Terjadi kesalahan saat membuat user. Periksa data yang dikirim.",
				},
				form: {
					name: "Nama",
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Daftar",
					login: "Sudah memiliki akun? Login!",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Masuk",
					register: "Belum punya akun? Daftar!",
				},
			},
			auth: {
				toasts: {
					success: "Login berhasil!",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Ticket hari ini: ",
					},
				},
				messages: {
					inAttendance: {
						title: "Dalam penanganan"
					},
					waiting: {
						title: "Menunggu"
					},
					closed: {
						title: "Ditutup"
					}
				},
				onlineUsers: {
					title: "User Online",
				},
			},
			connections: {
				title: "Koneksi",
				toasts: {
					deleted: "Koneksi WhatsApp berhasil dihapus!",
				},
				confirmationModal: {
					deleteTitle: "Hapus",
					deleteMessage: "Apakah Anda yakin? Hal ini tidak dapat dikembalikan.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Apakah Anda yakin? Anda perlu membaca QR Code lagi.",
				},
				buttons: {
					add: "Tambah WhatsApp",
					disconnect: "Disconnect",
					tryAgain: "Coba Lagi",
					qrcode: "QR CODE",
					newQr: "QR CODE Baru",
					connecting: "Menghubungkan..",
				},
				toolTips: {
					disconnected: {
						title: "Gagal memulai sesi WhatsApp",
						content:
							"Pastikan ponsel Anda terhubung ke internet dan coba lagi, atau minta QR Code baru",
					},
					qrcode: {
						title: "Menunggu QR Code dibaca",
						content:
							"Klik tombol 'QR CODE' dan baca QR Code dengan ponsel Anda untuk memulai sesi",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Koneksi dengan ponsel telah terputus",
						content:
							"Pastikan ponsel Anda terhubung ke internet dan WhatsApp terbuka, atau klik tombol 'Disconnect' untuk mendapatkan QR Code baru",
					},
				},
				table: {
					name: "Nama",
					status: "Status",
					lastUpdate: "Update Terakhir",
					default: "Default",
					actions: "Aksi",
					session: "Sesi",
				},
			},
			whatsappModal: {
				title: {
					add: "Tambah WhatsApp",
					edit: "Ubah WhatsApp",
				},
				form: {
					name: "Nama",
					default: "Default",
					farewellMessage: "Pesan Perpisahan",
				},
				buttons: {
					okAdd: "Tambah",
					okEdit: "Simpan",
					cancel: "Batal",
				},
				success: "WhatsApp berhasil disimpan.",
			},
			qrCode: {
				message: "Baca QrCode untuk memulai sesi",
			},
			contacts: {
				title: "Kontak",
				toasts: {
					deleted: "Kontak berhasil dihapus!",
				},
				searchPlaceholder: "Cari ...",
				confirmationModal: {
					deleteTitle: "Hapus",
					importTitlte: "Impor kontak",
					deleteMessage:
						"Apakah Anda yakin ingin menghapus kontak ini? Semua ticket terkait akan hilang.",
					importMessage: "Apakah Anda ingin mengimpor semua kontak dari telepon?",
				},
				buttons: {
					import: "Impor Kontak",
					add: "Tambah Kontak",
				},
				table: {
					name: "Nama",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Aksi",
				},
			},
			contactModal: {
				title: {
					add: "Tambah kontak",
					edit: "Ubah kontak",
				},
				form: {
					mainInfo: "Detail kontak",
					extraInfo: "Informasi tambahan",
					name: "Nama",
					number: "Nomor Whatsapp",
					email: "Email",
					extraName: "Field name",
					extraValue: "Value",
				},
				buttons: {
					addExtraInfo: "Tambah informasi",
					okAdd: "Tambah",
					okEdit: "Simpan",
					cancel: "Batal",
				},
				success: "Kontak berhasil disimpan.",
			},
			quickAnswersModal: {
				title: {
					add: "Add Quick Reply",
					edit: "Edit Quick Answer",
				},
				form: {
					shortcut: "Shortcut",
					message: "Quick Reply",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Quick Reply saved successfully.",
			},
			queueModal: {
				title: {
					add: "Tambah antrian",
					edit: "Ubah antrian",
				},
				form: {
					name: "Nama",
					color: "Warna",
					greetingMessage: "Greeting Message",
				},
				buttons: {
					okAdd: "Tambah",
					okEdit: "Simpan",
					cancel: "Batal",
				},
			},
			userModal: {
				title: {
					add: "Tambah user",
					edit: "Ubah user",
				},
				form: {
					name: "Nama",
					email: "Email",
					password: "Password",
					profile: "Profil",
					whatsapp: "Koneksi Default",
				},
				buttons: {
					okAdd: "Tambah",
					okEdit: "Simpan",
					cancel: "Batal",
				},
				success: "User berhasil disimpan.",
			},
			chat: {
				noTicketMessage: "Pilih ticket untuk mulai chat.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "New Chat",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Antrian",
			},
			tickets: {
				toasts: {
					deleted: "Ticket tempat Anda berada telah dihapus.",
				},
				notification: {
					message: "Pesan dari",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Terselesaikan" },
					search: { title: "Pencarian" },
				},
				search: {
					placeholder: "Cari ticket dan pesan.",
				},
				buttons: {
					showAll: "Semuanya",
				},
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Ketik untuk mencari user",
				fieldQueueLabel: "Transfer ke antrian",
				fieldConnectionLabel: "Transfer ke WhatsApp",
				fieldQueuePlaceholder: "Silakan pilih antrian",
				fieldConnectionPlaceholder: "Silakan pilih WhatsApp",
				noOptions: "Tidak ada user yang ditemukan dengan nama ini",
				buttons: {
					ok: "Transfer",
					cancel: "Batal",
				},
			},
			ticketsList: {
				pendingHeader: "Antrian",
				assignedHeader: "Sedang ditangani",
				noTicketsTitle: "Kosong!",
				noTicketsMessage: "Tidak ada ticket yang ditemukan.",
				connectionTitle: "Koneksi yang sedang digunakan.",
				buttons: {
					accept: "Ambil",
				},
			},
			newTicketModal: {
				title: "Buat Ticket",
				fieldLabel: "Ketik untuk mencari kontak",
				add: "Tambah",
				buttons: {
					ok: "Simpan",
					cancel: "Batal",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dasbor",
					connections: "Koneksi",
					tickets: "Ticket",
					contacts: "Kontak",
					queues: "Antrian",
					administration: "Administrasi",
					users: "User",
					settings: "Pengaturan",
				},
				appBar: {
					user: {
						profile: "Profil",
						logout: "Logout",
					},
				},
			},
			notifications: {
				noTickets: "Tidak ada notifikasi.",
			},
			queues: {
				title: "Antrian",
				table: {
					name: "Nama",
					color: "Warna",
					greeting: "Greeting message",
					actions: "Aksi",
				},
				buttons: {
					add: "Tambah antrian",
				},
				confirmationModal: {
					deleteTitle: "Hapus",
					deleteMessage:
						"Apakah Anda yakin? Hal ini tidak dapat dikembalikan! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
			},
			queueSelect: {
				inputLabel: "Antrian",
			},
			users: {
				title: "User",
				table: {
					name: "Nama",
					email: "Email",
					profile: "Profil",
					whatsapp: "Koneksi Default",
					actions: "Aksi",
				},
				buttons: {
					add: "Tambah user",
				},
				toasts: {
					deleted: "User berhasil dihapus.",
				},
				confirmationModal: {
					deleteTitle: "Hapus",
					deleteMessage:
						"Semua data user akan hilang. Ticket pengguna yang terbuka akan dipindahkan ke antrian.",
				},
			},
			settings: {
				success: "Pengaturan berhasil disimpan.",
				title: "Pengaturan",
				settings: {
					userCreation: {
						name: "Pembuatan user",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Kembalikan",
						resolve: "Terselesaikan",
						reopen: "Buka kembali",
						accept: "Ambil",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Ketik pesan atau tekan ''/'' untuk menggunakan quick responses",
				placeholderClosed: "Buka kembali atau 'Ambil' ticket ini untuk mengirim pesan.",
				signMessage: "Sign",
			},
			contactDrawer: {
				header: "Detail kontak",
				buttons: {
					edit: "Ubah kontak",
				},
				extraInfo: "Informasi lainnya",
			},
			ticketOptionsMenu: {
				delete: "Hapus",
				transfer: "Transfer",
				confirmationModal: {
					title: "Hapus ticket #",
					titleFrom: "dari kontak ",
					message: "Perhatian! Semua pesan terkait ticket akan hilang.",
				},
				buttons: {
					delete: "Hapus",
					cancel: "Batal",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Batal",
				},
			},
			messageOptionsMenu: {
				delete: "Hapus",
				reply: "Reply",
				confirmationModal: {
					title: "Hapus pesan?",
					message: "Tindakan ini tidak dapat dikembalikan.",
				},
			},
			userLogs: {
				title: "Log Login User",
				table: {
					loginTime: "Waktu Login",
					lastAccess: "Akses Terakhir",
					logoutTime: "Waktu Logout",
					user: "User",
					ipAddress: "Alamat IP",
				},
			},
			backendErrors: {
				ERR_NO_OTHER_WHATSAPP:
					"Harus ada setidaknya satu koneksi default WhatsApp.",
				ERR_NO_DEF_WAPP_FOUND:
					"Tidak ada default WhatsApp yang ditemukan. Cek halaman koneksi.",
				ERR_WAPP_NOT_INITIALIZED:
					"Sesi WhatsApp ini belum diinisialisasi. Ceek halaman koneksi.",
				ERR_WAPP_CHECK_CONTACT:
					"Tidak dapat mengecek kontak WhatsApp. Cek halaman koneksi.",
				ERR_WAPP_INVALID_CONTACT: "Ini bukan nomor WhatsApp yang valid.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Tidak dapat men-download media dari WhatsApp. Cek halaman koneksi.",
				ERR_INVALID_CREDENTIALS: "Autentikasi error. Silakan coba lagi.",
				ERR_SENDING_WAPP_MSG:
					"Terjadi kesalahan saat mengirim pesan WhatsApp. Cek halaman koneksi.",
				ERR_DELETE_WAPP_MSG: "Tidak dapat menghapus pesan dari WhatsApp.",
				ERR_OTHER_OPEN_TICKET:
					"Sudah ada ticket terbuka untuk kontak ini.",
				ERR_SESSION_EXPIRED: "Sesi expired. Silakan login.",
				ERR_USER_CREATION_DISABLED:
					"Pendaftaran user dinonaktifkan oleh administrator.",
				ERR_NO_PERMISSION: "Anda tidak memiliki izin untuk mengakses resource ini.",
				ERR_DUPLICATED_CONTACT: "Kontak dengan nomor ini sudah ada sebelumnya.",
				ERR_NO_SETTING_FOUND: "Tidak ada setting yang ditemukan dengan ID ini.",
				ERR_NO_CONTACT_FOUND: "Tidak ada kontak yang ditemukan dengan ID ini.",
				ERR_NO_TICKET_FOUND: "Tidak ada ticket yang ditemukan dengan ID ini.",
				ERR_NO_USER_FOUND: "Tidak ada user yang ditemukan dengan ID ini.",
				ERR_NO_WAPP_FOUND: "Tidak ada WhatsApp yang ditemukan dengan ID ini.",
				ERR_CREATING_MESSAGE: "Error saat membuat pesan pada database.",
				ERR_CREATING_TICKET: "Error saat membuat tiket pada database.",
				ERR_FETCH_WAPP_MSG:
					"Error saat mengambil pesan 'quote' di WhtasApp, ID tidak ditemukan, atau mungkin pesan sudah terlalu lama.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"Warna ini sudah digunakan, pilih yang lain.",
				ERR_WAPP_GREETING_REQUIRED:
					"Greeting message diperlukan jika ada lebih dari satu antrian.",
			},
		},
	},
};

export { messages };
